import { render } from "./site-footer.vue?vue&type=template&id=2e6db09b"
import script from "./site-footer.vue?vue&type=script&lang=js"
export * from "./site-footer.vue?vue&type=script&lang=js"

import "./site-footer.vue?vue&type=style&index=0&id=2e6db09b&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__